import React from 'react';
import Load from "../assets/load.gif"
import './Loading.scss';

const Loading = () => {
    return (
        <div className="game-store-loading-screen">

            <div className="loading">
                <img src={Load} alt="load" className="load" />

                <p className="loading-text">Загрузка магазина</p>

            </div>
        </div>
    );
};

export default Loading;
